import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function load (name) {
  return require('../components/' + name + '.vue')
}


var mode =  (process.env.NODE_ENV != 'development') ? 'history' : 'hash' 

export default new Router({

  mode: mode,
  base: '/bams/',

  routes: [
    { path: '/', name: 'home'}, 
    /*
    { path: '/home', name: 'home', meta: { nav: true }, components:{main: load('Home') } }, 
    */
    { path: '/abs-new', name: 'absNew', meta: { nav: true }, components:{main: load('Abs-new') } }, 
    { path: '/inviato', name: 'inviato', meta: { nav: true }, components:{main: load('Inviato') } }, 

    { path: '/chiuso', name: 'chiuso', meta: { nav: true }, components:{main: load('Chiuso') } }, 

    { path: '/start/:evento', name: 'start' },
    { path: '/startnodeadline/:evento', name: 'startnodeadline' },
    { path: '/start/:evento/abs/:abstract', name: 'startAbs' },
    { path: '/edit/:abstract/:premail', name: 'edit' },


    { path: '/consulta', name: 'consulta', meta: { nav: true }, components:{main: load('Abs-consulta') } }, 
    { path: '/startconsulta/:evento*', name: 'startconsulta' },


    /*
    { path: '/inside/:area/:page', name: 'inside', meta: { nav: true }, components:{main: load('Inside') } }, 
    
    { path: '*', component: load('Home') } // Not found
    */
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js